import React from 'react';
import { Typography, LinkButton } from 'fronton-react';
import clsx from 'clsx';
import { linkSpace, secondaryItem, stretchedLink } from './styles';
import { SecondaryMenuItemProps } from './types';
import { isLink } from './utils';

export const SecondaryMenuItem = (props: SecondaryMenuItemProps) => {
  const { title, icon: Icon, customIcon, className, ...rest } = props;

  const buttonProps = isLink(props) ? { href: props.href } : { onClick: props.onClick };

  return (
    <LinkButton {...rest} as="a" className={clsx(secondaryItem, stretchedLink, className)} {...buttonProps}>
      <div className={linkSpace}>
        {Icon && <Icon type="outline" size="l" color="text-primary" />}
        {customIcon && <>{customIcon}</>}
        <Typography variant="m" size="body_long">
          {title}
        </Typography>
      </div>
    </LinkButton>
  );
};
